// src/App.js
import React, { useEffect, useState, createContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import SubcategoryPage from "./pages/SubcategoryPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import "./App.css";
import About from "./pages/About";
import Article from "./pages/Article";

// NEW: import TermsPrivacy page
import TermsPrivacy from "./pages/TermsPrivacy";

export const AppContext = createContext();

const PageTransition = ({ children }) => (
  <div className="min-h-screen">{children}</div>
);

const AnimatedRoutes = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [direction, setDirection] = useState("forward");
  const [language, setLanguage] = useState("el");
  const [search, setSearch] = useState("");
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    const userLang = navigator.language || navigator.userLanguage;
    if (userLang.toLowerCase().startsWith("en")) setLanguage("en");
  }, []);

  useEffect(() => {
    setDirection(navigationType === "POP" ? "back" : "forward");
  }, [navigationType, location]);

  return (
    <AppContext.Provider
      value={{
        language,
        setLanguage,
        search,
        setSearch,
        pageTitle,
        setPageTitle,
        direction,
      }}
    >
      <Header />
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <HomePage />
            </PageTransition>
          }
        />
        <Route
          path="/category/:id"
          element={
            <PageTransition>
              <CategoryPage />
            </PageTransition>
          }
        />
        <Route
          path="/subcategory/:id"
          element={
            <PageTransition>
              <SubcategoryPage />
            </PageTransition>
          }
        />
        {/* NEW: Terms & Privacy */}
        <Route
          path="/terms"
          element={
            <PageTransition>
              <TermsPrivacy />
            </PageTransition>
          }
				/>
				<Route
		  path="/about"
		  element={
			<PageTransition>
			  <About />
			</PageTransition>
		  }
		/>

		<Route
		  path="/article/:id"
		  element={
			<PageTransition>
			  <Article />
			</PageTransition>
		  }
		/>
      </Routes>
      <Footer />
      <CookieBanner />
    </AppContext.Provider>
  );
};

export default function App() {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const measure = () => {
      const el = document.querySelector("header");
      setHeaderHeight(el ? el.offsetHeight : 0);
    };
    measure();

    const el = document.querySelector("header");
    let ro = null;
    if (el && "ResizeObserver" in window) {
      ro = new ResizeObserver(measure);
      ro.observe(el);
    }

    window.addEventListener("resize", measure);
    return () => {
      window.removeEventListener("resize", measure);
      if (ro) ro.disconnect();
    };
  }, []);

  return (
    <Router>
      <div
        className="flex flex-col min-h-screen"
        style={{ paddingTop: headerHeight }}
      >
        <AnimatedRoutes />
      </div>
    </Router>
  );
}
